export {default} from './CollectLayout';
